NtechApp.ChatsList = function($view) {
    var me = this;

    this._$view = null;

    this._selectedChatId = null;

    this._ajax = null;
    this._click = null;

    this._construct = function() {
        me._$view = $view;

        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._updateMessageTexts();

        me._bindEvents();
        me._bindAjaxPollingUpdates();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-loadNextChatsPage]", function(event) {
            var $item = $(event.target).closest("[data-loadNextChatsPage]");

            if($item.hasClass("lockLoadNextButton"))
                return;

            $item.addClass("lockLoadNextButton");
            me._loadNextListItems($item);
        });

        me._click.listen(me._$view, "[data-chatModel]", function(event) {
            var $item = $(event.target).closest("[data-chatModel]");
            me.selectChatById($item.attr("data-chatModel"));
        });

        $(window).on("resize.NtechApp.ChatsList", function() {
            me._updateMessageTexts();
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_CHAT_MESSAGES_VIEWED, function(e, chatId) {
            var $chat = me._$view.find("[data-chatModel='" + chatId + "']");
            $chat.find("[data-chatNotViewedMessagesCounter]").css("display", "none");
        });

        $(window).on(NtechApp.WINDOW_EVENTS.EVENT_MARK_ALL_READ, function() {
            me._$view.find("[data-chatNotViewedMessagesCounter]").css("display", "none");
        });
    }

    this._bindAjaxPollingUpdates = function() {
        NtechApp.ajaxPolling.addPullRequestParamsResolver(function() {
            var $chats = me._$view.find("[data-chatModel]");
            var $chatWithLatestDate = NtechApp.dateTools.getItemWithLatestDate(
                $chats, "data-updatedAt"
            );
            //var chatsCount = $chats.length;

            var $loadNextChatsPage = me._$view.find("[data-loadNextChatsPage]");
            if($loadNextChatsPage.length > 0)
                var chatsNextPage = $loadNextChatsPage.attr("data-loadNextChatsPage");
            else
                var chatsNextPage = null;

            var params = {};
            if($chatWithLatestDate != null) {
                params["pullChatsList"] = $chatWithLatestDate.attr("data-updatedAt");
                //params["pullChatsListCount"] = chatsCount;
                params["pullChatsListNextPage"] = chatsNextPage;
            }
            else {
                params["pullAllChatsList"] = true;
            }

            return params;
        });

        $(NtechApp.ajaxPolling).on(NtechApp.AjaxPolling.EVENT_ON_DATA_PULL, function(e, data) {
            if(!data.wasChatsListUpdated)
                return;

            me._$view.find("[data-chatModel]").remove();
            me._$view.find("[data-loadNextChatsPage]").remove();

            for(var i = 0; i < data.chatListHtmlParts.length; i++) {
                var chatsHtml = data.chatListHtmlParts[i];
                var $chatsHtml = $($.parseHTML(chatsHtml));

                me._$view.find("[data-chatsListGridContent]").append($chatsHtml);
                if(i != data.chatListHtmlParts.length - 1) {
                    me._$view.find("[data-loadNextChatsPage]").remove();
                }
            }

            NtechApp.dateTools.convertDates(me._$view);

            if(data.noChatsInList)
                me._hideChatsGrid();
            else
                me._showChatsGrid();

            // @todo -> On chat destroy/All chats destroy send destroy event
            // +remove openedChatId from chatMessagesForm + closeForm????

            // Some chat was selected before update
            if(me._selectedChatId != null) {
                me.selectChatById(me._selectedChatId, true);
            }
            // No chats existed before update(selecting first chat)
            else if(!data.noChatsInList) {
                me.selectLatestChatIfExists(true);
            }
            // All chats were deleted
            else {
                me._selectedChatId = null;
            }
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.ChatsList.EVENT_CHAT_SELECT = "NtechApp.ChatsList.EventChatSelect";

NtechApp.proto(NtechApp.ChatsList, {
    _getLoadNextChatsRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_load_next_chats_list_page';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_load_next_chats_list_page';
    },

    _updateMessageTexts: function() {
        var me = this;
        $.each(this._$view.find("[data-chatMessage]"), function() {
            me._updateMessageText($(this));
        });
    },

    _updateMessageText: function($item) {
        if(NtechApp.isMobile() && !NtechApp.isMobile599() && $(window).width() > 800)
            var count = 120;
        else if(NtechApp.isMobile() && !NtechApp.isMobile599())
            var count = 80;
        else
            var count = 35;

        var text = $item.attr("data-chatMessageText");
        text = (text.length >= count) ? $.trim(text.substr(0, count)) + '...' : text;

        $item.text(text);
    },

    _showChatsGrid: function() {
        var $noItems = this._$view.find("[data-chatsListNoItems]");
        var $itemsGrid = this._$view.find("[data-chatsListGrid]");

        $noItems.addClass("hidden");
        $itemsGrid.removeClass("hiddenGrid");
    },

    _hideChatsGrid: function() {
        var $noItems = this._$view.find("[data-chatsListNoItems]");
        var $itemsGrid = this._$view.find("[data-chatsListGrid]");

        $noItems.removeClass("hidden");
        $itemsGrid.addClass("hiddenGrid");
    },

    _scrollToTop: function() {
        this._$view.find(".scrollableContent").scrollTop(0);
    },

    _scrollToChat: function($chat, extraOffset) {
        var $view = this._$view.find(".scrollableContent");
        var extraOffset = extraOffset || 0;

        $view.scrollTop($chat.position().top - extraOffset);
    },

    selectLatestChatIfExists: function(restrictEvent) {
        var restrictEvent = restrictEvent || false;
        var $chats = this._$view.find("[data-chatModel]");
        if($chats.length == 0)
            return;

        var $firstChat = $chats.first();
        this.selectChatById($firstChat.attr("data-chatModel"), restrictEvent);
    },

    selectAndScrollToChat: function(chatId) {
        this.selectChatById(chatId);
        this._scrollToChat(this._$view.find("[data-chatModel='" + this._selectedChatId + "']"));
    },

    selectChatById: function(chatId, restrictEvent) {
        var restrictEvent = restrictEvent || false;
        if(parseInt(chatId, 10) < 0)
            return;

        var $chatItem = this._$view.find("[data-chatModel='" + chatId + "']");
        //if($chatItem.hasClass("selectedItem"))
        //    return false;

        this._$view.find("[data-chatModel]").removeClass("selectedItem");
        $chatItem.addClass("selectedItem");
        this._selectedChatId = chatId;

        NtechApp.currentChatIdForFixtures = this._selectedChatId;
        if(!restrictEvent)
            this._emitChatSelectEvent();
    },

    getSelectedChatId: function() {
        return this._selectedChatId;
    },

    _emitChatSelectEvent: function() {
        $(this).trigger(NtechApp.ChatsList.EVENT_CHAT_SELECT, [this._selectedChatId]);
    },

    _loadNextListItems: function($item) {
        var me = this;
        var page = $item.attr("data-loadNextChatsPage");

        me._ajax.enableTextLoading($item);

        var params = {
            nextPage: page || 0
        };

        me._ajax.get({
            url: Routing.generate(me._getLoadNextChatsRoute(), params),
            onSuccess: function(data) {
                $item.remove();
                me._$view.find("[data-chatModel]").last().parent().append(
                    $($.parseHTML(data.html))
                );

                NtechApp.dateTools.convertDates(me._$view);
            },
            onComplete: function() {
                //if(me._nextLoadRequestData == null)
                //    me._loaderOff();
            }
        });
    },

    moveSelectedChatToTop: function() {
        this.scrollChatToTop(this._selectedChatId);
    },

    scrollChatToTop: function(chatId) {
        var $wrapper = this._$view.find(".columnContentWrapper");
        var $targetChat = this._$view.find("[data-chatModel='" + chatId + "']");

        $wrapper.prepend($targetChat);
        this._scrollToTop();
    },

    processNewMessage: function(chatId, message, messageDate) {
        var $wrapper = this._$view.find(".columnContentWrapper");
        var $targetChat = this._$view.find("[data-chatModel='" + chatId + "']");

        $targetChat.find("[data-chatDatetime]").attr("data-datetimeFromUtc", messageDate);
        NtechApp.dateTools.convert($targetChat.find("[data-datetimeFromUtc]"));

        $targetChat.find("[data-chatMessage]").attr("data-chatMessageText", message);
        this._updateMessageText($targetChat.find("[data-chatMessage]"));
    }
});